<template>
  <v-app>
    <transition name="slide-down" appear>
      <div v-if="!loading" key="services">
        <top-bar />
        <div id="services-page" class="page">
          <div class="center-align" v-if="noServices">
            <div class="light">
              You haven't set up any services yet. Add one below:
            </div>
          </div>
          <services-list :services="services" v-else />
          <div class="center-align pa-3">
            <div class="btn btn-primary" @click="createService">
              <div class="fa fa-plus" />
              Add Service
            </div>

            <div
              class="btn btn-secondary"
              @click="setUndeleteModal"
              :disabled="undeletableServices.length < 1"
            >
              <div class="fa fa-recycle" />
              Undelete Service
            </div>
          </div>

          <undelete-modal
            v-if="undeleteModal"
            :undeletables="undeletableServices"
          />
          <v-snackbar
            :timeout="2000"
            color="success"
            class="show-saved-snackbar"
            left
            v-model="showSaved"
          >
            Saved!
          </v-snackbar>
          <v-snackbar
            v-for="(error, index) in serviceErrors"
            :key="index"
            :timeout="isMobile ? 10000 : 0"
            color="error"
            class="show-error-snackbar"
            left
            v-model="showError"
          >
            {{ error }}
            <v-btn flat @click.native="shiftError" class="pl-3 pr-0 mx-0">
              <div class="fa fa-close" />
            </v-btn>
          </v-snackbar>
        </div>
      </div>
      <v-container fluid v-if="loading" key="loading-screen">
        <v-layout row>
          <v-flex s12 mt-5 center-align>
            <h1 class="px-0">Loading Services</h1>
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex s12 center-align>
            <v-progress-circular :value="progress()" color="info" :size="100" />
          </v-flex>
        </v-layout>
      </v-container>
    </transition>
  </v-app>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import Service from '../../models/Service'
import ServicesList from './ServicesList'
import TopBar from './TopBar'
import UndeleteModal from './modal/UndeleteService'

export default {
  components: {
    ServicesList,
    TopBar,
    UndeleteModal,
  },
  computed: {
    ...mapState('services', [
      'agreements',
      'company',
      'loadingAgreements',
      'loadingServices',
      'loadingTemplates',
      'services',
      'showSaved',
      'templates',
      'undeletableServices',
      'undeleteModal',
      'userProfile',
    ]),
    ...mapState('services', {
      serviceErrors: 'errors', // errors is a vue component reserved word
    }),
    noServices() {
      return !this.loading && this.services.length === 0
    },
    showError: {
      get() {
        return this.$store.state.services.showError
      },
      set(newValue) {
        return this.$store.commit('services/setShowError', newValue)
      },
    },
    showSaved: {
      get() {
        return this.$store.state.services.showSaved
      },
      set(newValue) {
        return this.$store.commit('services/setShowSaved', newValue)
      },
    },
  },
  data() {
    return {
      loading: true,
    }
  },
  methods: {
    ...mapMutations('services', ['shiftError', 'setUndeleteModal']),
    createService() {
      let service = JSON.parse(JSON.stringify(Service))
      service.attributes.company_id = this.company.id
      service.attributes.priority = this.services.length
      this.$store.dispatch('services/createService', service)
    },
    fetchCompany() {
      const companyId =
        this.$route.query.company_id || this.userProfile.attributes.company_id
      return this.$store.dispatch('services/fetchCompany', companyId)
    },
    isMobile() {
      return this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm
    },
    progress() {
      let prog = 0
      if (this.company.id) prog += 25
      if (this.loadingServices === false) prog += 25
      if (this.loadingTemplates === false) prog += 25
      if (this.loadingAgreements === false) prog += 25

      if (prog === 100)
        setTimeout(() => {
          this.loading = false
        }, 500)

      return prog
    },
  },
  mounted() {
    this.$store.dispatch('services/fetchUserProfile').then(() => {
      this.fetchCompany().then(() => {
        if (this.company.attributes.settings.enable_spectora_network) {
          this.$store.dispatch('services/fetchServiceClassifications')
        }
      })
    })
  },
  watch: {
    company: function (newValue, oldValue) {
      if (!oldValue.id) {
        this.$store.dispatch('services/fetchTemplates')
        this.$store.dispatch('services/fetchAgreements')
        this.$store.dispatch('services/fetchServiceCategories')
        this.$store.dispatch('services/fetchCustomFields').then(() => {
          this.$store.dispatch('services/fetchServices', { detailed: true })
        })
        this.$store.dispatch('services/fetchServices', { deleted: true })
      }
    },
  },
}
</script>

<style scoped>
.slide-down-enter-active,
.slide-down-leave-active {
  transition: all 0.3s ease;
}
.slide-down-enter-active {
  transition-delay: 0.5s;
}
.slide-down-enter-active.no-delay {
  transition-delay: 0s;
}
.slide-down-enter,
.slide-down-leave-to {
  transform: translateY(-10px);
  opacity: 0;
}
</style>

<style>
#services-page .v-snack__wrapper.error .v-snack__content {
  color: #fff;
}
</style>
